import { ChangeDetectionStrategy, Component } from '@angular/core';
import { BaseTypographyComponent } from '../base-typography.component';
import { CommonModule } from '@angular/common'; 
@Component({
  selector: 'app-body-md',
  template: '<span [ngClass]="ngClass"><ng-content></ng-content></span>',
  styleUrls: ['./body-medium.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    CommonModule
  ]
})
export class BodyMediumComponent extends BaseTypographyComponent {}
